import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'

const Loader: React.FC = () => {
  return (
    <Box
      display='flex'
      flexDirection='column'
      justifyContent='center'
      alignItems='center'
      height='100vh'
      gap={2}
    >
      <CircularProgress color='primary' />
      <Typography variant='h6' color='text.secondary'>
        Loading, please wait...
      </Typography>
    </Box>
  )
}

export default Loader
